export enum SeasonStatusEnum {
  DRAFT = 'draft',
  ACTIVE = 'active',
  FINISHED = 'finished',
}

export enum SeasonalQuestTypeEnum {
  /** Сделать N ставок в любой игре. params: { agentKey?: string, targetCount: number } */
  MAKE_BETS_COUNT = 'make_bets_count',
  /** Выиграть на суммарную сумму N (только rounds с profit > 0). params: { agentKey?: string, targetAmount: number } */
  WIN_AMOUNT = 'win_amount',
  /** Поставить на суммарную сумму N (сумма всех ставок). params: { agentKey?: string, targetAmount: number } */
  WAGER_AMOUNT = 'wager_amount',
  /** Сыграть N игр. params: { agentKey?: string, targetCount: number } */
  GAMES_COUNT = 'games_count',
  /** Double: выиграть N раз на зелёном за скользящее окно времени. params: { agentKey?: string, targetCount: number, windowMs?: number } */
  DOUBLE_GREEN_KING = 'double_green_king',
  /** Double: выиграть на зелёном → проиграть на зелёном → снова выиграть на зелёном. params: { agentKey?: string, resetOnBrokenSequence?: boolean } */
  DOUBLE_GREEN_WIN_LOSE_WIN = 'double_green_win_lose_win',
  /** Double: выиграть поочерёдно на цветах в заданной последовательности. params: { agentKey?: string, sequence: DoubleBetTypeEnum[], requireConsecutive?: boolean } */
  DOUBLE_COLOR_SEQUENCE = 'double_color_sequence',
  /** Double: выиграть после серии из N проигрышей подряд (любой цвет). params: { agentKey?: string, targetLosses: number } */
  DOUBLE_LOSS_STREAK_THEN_WIN = 'double_loss_streak_then_win',
  /** Double: стать победителем джекпота (три зелёных подряд). params: { agentKey?: string } */
  DOUBLE_JACKPOT = 'double_jackpot',
  /** Double: поставить на любой цвет в N подряд идущих раундах, завершившихся зелёным (=свидетель джекпота). params: { agentKey?: string, targetValue: number } */
  DOUBLE_JACKPOT_WITNESS = 'double_jackpot_witness',
  /** Double: выиграть на любом цвете в раунде сразу после джекпота. params: { agentKey?: string } */
  DOUBLE_WAVE_CATCHER = 'double_wave_catcher',

  // ─── x50 ────────────────────────────────────────────────────────────────────

  /** x50: поставить на любой сектор в раунде, где выпал x50 (GREEN). params: { agentKey?: string } */
  X50_WITNESS = 'x50_witness',
  /** x50: выиграть поочерёдно на секторах в заданной последовательности. params: { agentKey?: string, sequence: X50BetTypeEnum[], requireConsecutive?: boolean } */
  X50_COLOR_SEQUENCE = 'x50_color_sequence',
  /** x50: проиграть N раз подряд на заданном секторе, затем выиграть на другом. params: { agentKey?: string, targetLosses: number, lossColorType: X50BetTypeEnum, winColorType: X50BetTypeEnum } */
  X50_LOSS_STREAK_THEN_WIN = 'x50_loss_streak_then_win',
  /** x50: выиграть на x50 (GREEN), если в предыдущем раунде выпал заданный сектор. params: { agentKey?: string, prevColorType: X50BetTypeEnum } */
  X50_SANDWICH = 'x50_sandwich',
  /** x50: сделать N ставок подряд на GREEN, поймав хотя бы одну победу. params: { agentKey?: string, targetBets: number } */
  X50_HEADHUNTER = 'x50_headhunter',
  /** x50: выиграть N раз подряд (любой сектор). params: { agentKey?: string, targetWins: number } */
  X50_WIN_STREAK = 'x50_win_streak',

  // ─── hilo ───────────────────────────────────────────────────────────────────

  /** HiLo: выиграть N раз подряд на заданных типах ставок. params: { betTypes: HiloBetTypeEnum[], targetValue: number, requireConsecutive?: boolean } */
  HILO_BET_TYPE_WIN_STREAK = 'hilo_bet_type_win_streak',
  /** HiLo: накопить N побед на высокорисковых ставках (joker/ace). params: { betTypes: HiloBetTypeEnum[], targetValue: number } */
  HILO_HIGH_RISK_WIN = 'hilo_high_risk_win',
  /** HiLo: поставить на джокера сразу после того как выпал джокер и выиграть. params: { targetValue: 1 } */
  HILO_JOKER_AFTER_JOKER = 'hilo_joker_after_joker',
  /** HiLo: выиграть на каждом типе ставки по одному разу. params: { targetValue: 9 } */
  HILO_FULL_CIRCLE = 'hilo_full_circle',
  /** HiLo: проиграть N ставок подряд не на джокере, затем выиграть на джокере. params: { targetValue: N+1 } */
  HILO_LOSS_STREAK_THEN_JOKER = 'hilo_loss_streak_then_joker',

  // ─── classic / fast ─────────────────────────────────────────────────────────

  /** Classic/Fast: победить с шансом менее X%. params: { agentKey, chanceThreshold: 0.05, targetValue } */
  CLASSIC_LOTTERY_TICKET = 'classic_lottery_ticket',
  /** Classic/Fast: внести предметов на сумму >= betThreshold в один раунд. params: { agentKey, betThreshold, targetValue: 1 } */
  CLASSIC_HIGH_BET = 'classic_high_bet',
  /** Classic/Fast: выиграть N раз подряд в раундах 1v1. params: { agentKey, targetValue } */
  CLASSIC_WIN_STREAK_1V1 = 'classic_win_streak_1v1',
  /** Classic/Fast: внести >= itemThreshold предметов с ценой >= itemMinPrice в один раунд. params: { agentKey, itemThreshold: 15, itemMinPrice: 0|100|500, targetValue: 1 } */
  CLASSIC_COLLECTOR = 'classic_collector',
  /** Classic/Fast: последним внести ставку и победить. params: { agentKey, targetValue } */
  CLASSIC_SNIPER = 'classic_sniper',
  /** Classic/Fast: текстовое представление банка (в рублях) совпадает с одним из patterns — суффикс/префикс/точное значение, см. IClassicBeautifulNumberParams. params: { agentKey, targetValue, patterns: string[] } */
  CLASSIC_BEAUTIFUL_NUMBER = 'classic_beautiful_number',

  // ─── общие ──────────────────────────────────────────────────────────────────

  /**
   * Сделать ставку >= percentage от суммы депозита первой ставкой после пополнения.
   * params: { percentage: number } (например 0.5 для "Авось", 1.0 для "ALL-IN")
   */
  BET_AFTER_DEPOSIT = 'bet_after_deposit',

  // ─── cashback ───────────────────────────────────────────────────────────────

  /**
   * Бесконечный cashback-квест: начисляет percentage от каждой проигрышной ставки в score.
   * Активируется автоматически (IN_PROGRESS → CONTINUES) когда totalWagered достигает targetWager.
   * При пересечении порога — кэшбэк только на overflow-часть проигрышной ставки.
   * Claim доступен когда (earnedCashback - paidCashback) >= 10000 (накоплено >= 1 целого очка).
   * params: { agentKey, targetWager: number, percentage: number }
   * progress: { totalWagered, earnedCashback, paidCashback } — все × 10000
   */
  LOSING_BET_CASHBACK = 'losing_bet_cashback',

  // ─── social ─────────────────────────────────────────────────────────────────

  /**
   * Привязать email. Не создаётся, если email уже подтверждён.
   * Завершается по событию UserEventEnum.CONFIRM_EMAIL.
   * params: {} (только базовые поля IBaseQuestParams)
   */
  BIND_EMAIL = 'bind_email',

  /**
   * Подписаться на push-уведомления. Не создаётся, если уже подписан.
   * Завершается по событию UserEventEnum.SUBSCRIBE с isPushSubscribe=true.
   * params: {} (только базовые поля IBaseQuestParams)
   */
  SUBSCRIBE_PUSH = 'subscribe_push',

  /**
   * Подписаться на социальную сеть. Выдаётся каждый сезон под каждую соцсеть отдельным definition.
   * Завершается по нажатию кнопки (redirect endpoint). Тип соцсети хранится в params.socialNetwork.
   * params: { socialNetwork: SocialNetworkEnum, url: string }
   */
  SOCIAL_SUBSCRIBE = 'social_subscribe',

  // ── Кейс-баттлы (agentKey 'case-battles', события с ICaseBattleGameResultMeta) ──
  // Все типы поддерживают базовые params IBaseCaseBattleQuestParams: presetId (фильтр
  // по пресету), presetName (снапшот для отображения), targetValue (дефолт 1), countBots.

  /** Победа с отрывом меньше marginPercent% от total победителя. params: { marginPercent } */
  CASE_BATTLE_CLOSE_WIN = 'case_battle_close_win',

  /** Команда выиграла, а MVP батла (макс. личная сумма дропа) — игрок другой команды */
  CASE_BATTLE_ENEMY_MVP_WIN = 'case_battle_enemy_mvp_win',

  /** Команда выиграла, а самый дорогой дроп батла — у другой команды */
  CASE_BATTLE_CROWNLESS_WIN = 'case_battle_crownless_win',

  /** Победа после проигрыша первых roundsLost раундов. params: { roundsLost } */
  CASE_BATTLE_COMEBACK_WIN = 'case_battle_comeback_win',

  /** Победа без лидерства перед финальным раундом (isWinBattle=false в предпоследнем раунде) */
  CASE_BATTLE_NOT_LEADER_BEFORE_LAST_WIN = 'case_battle_not_leader_before_last_win',

  /** Победа, держа самый дорогой дроп всего батла */
  CASE_BATTLE_TOP_DROP_WIN = 'case_battle_top_drop_win',

  /** lossesRequired поражений одному сопернику (суммарно за сезон), затем победа над ним. Только 1v1. params: { lossesRequired } */
  CASE_BATTLE_NEMESIS_WIN = 'case_battle_nemesis_win',

  /** lossStreakRequired поражений подряд (любой пресет), затем победа в батле с суммой своих дропов больше суммы в проигрышах. params: { lossStreakRequired } */
  CASE_BATTLE_DEBT_PAID_WIN = 'case_battle_debt_paid_win',

  /** winsRequired побед подряд против одного соперника (чужие батлы рвут серию). Только 1v1. params: { winsRequired } */
  CASE_BATTLE_OPPONENT_WIN_STREAK = 'case_battle_opponent_win_streak',

  /** Победа, проиграв все раунды кроме последнего */
  CASE_BATTLE_LOSE_ALL_BUT_LAST_WIN = 'case_battle_lose_all_but_last_win',

  /** Победа, выиграв ровно roundsWon раундов (дефолт 1). params: { roundsWon? } */
  CASE_BATTLE_SINGLE_ROUND_WIN = 'case_battle_single_round_win',

  /** Проиграть батл, затем выиграть батл-реванш этого же батла (meta.revengeOriginalBattleId). params: базовые */
  CASE_BATTLE_REVENGE_WIN = 'case_battle_revenge_win',
}

export enum SeasonalQuestInstanceStatusEnum {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CLAIMED = 'claimed',
  /** Бесконечный квест в процессе выполнения (например losing_bet_cashback). Никогда не переходит в CLAIMED. */
  CONTINUES = 'continues',
}

/**
 * Как квест отображается на фронте (задаётся админом при создании, хранится в БД,
 * не влияет на логику вычисления прогресса — только на способ рендера).
 *
 * - STAGE_GAMES — этапный квест, прогресс измеряется количеством игр/раундов
 * - STAGE_WAGER — этапный квест, прогресс измеряется суммой ставок
 * - TARGET      — одноразовое попадание в условие (выиграть с шансом <X%, поймать конкретный
 *                 исход) без накопительного прогресс-бара
 * - CHAIN       — цепочка условий (nemesis/debt/streak — многошаговая stateful-механика)
 * - COLLECT     — сбор набора (classic_collector и т.п.)
 * - FULL_CIRCLE — сбор набора без повторов, порядок не важен (hilo_full_circle и аналоги
 *                 в x50/double)
 * - COMMON      — обычный счётчик/прогресс-бар (по умолчанию для большинства квестов)
 */
export enum SeasonalQuestDisplayTypeEnum {
  STAGE_GAMES = 'stage-games',
  STAGE_WAGER = 'stage-wager',
  TARGET = 'target',
  CHAIN = 'chain',
  COLLECT = 'collect',
  FULL_CIRCLE = 'full-circle',
  COMMON = 'common',
}

/** HTTP sortBy списка сезонов: без префикса — ASC, с «-» — DESC; API преобразует в ISort */
export enum SeasonSortByEnum {
  StartAt = 'startAt',
  NegativeStartAt = '-startAt',
  EndAt = 'endAt',
  NegativeEndAt = '-endAt',
}

/** HTTP sortBy истории квестов: без префикса — ASC, с «-» — DESC; API преобразует в ISort */
export enum SeasonalQuestUserInstancesSortByEnum {
  CompletedAt = 'completedAt',
  NegativeCompletedAt = '-completedAt',
  ClaimedAt = 'claimedAt',
  NegativeClaimedAt = '-claimedAt',
}

/** HTTP sortBy наград за очки: без префикса — ASC, с «-» — DESC; API преобразует в ISort */
export enum SeasonalQuestScoreRewardsSortByEnum {
  Score = 'score',
  NegativeScore = '-score',
}
